export const en = {
  translation: {
    yes: 'Yes',
    no: 'No',
    i_dont_know: 'I do not know',
    loading: 'Loading',
    error: 'Error',
    what_its_about: 'What is the reason for contacting us?',
    illness: 'Illness/symptom',
    other_reason: 'Other',
    next: 'Next',
    digichat247: 'Digital Nurse chat for occupational health customers 24/7',
    return_to_start: 'Go back and clear the answers',
    start_by_giving_anamnesis: 'Start by giving the preliminary information',
    chat_preliminary_questionaire: 'Preliminary information survey for the chat',
    start_preliminary_questionaire: 'Start the preliminary information survey',
    search: 'Search',
    search_for_symptoms: 'Search for a symptom or an illness',
    search_continue_writing: 'Continue writing',
    search_no_results: 'No results',
    step_your_symptoms: 'Symptoms',
    step_questions: 'Questions',
    step_summary: 'Summary',
    what_symptoms_you_have: 'What symptoms do you have?',
    most_popular_symptoms: 'The most common symptoms',
    select_symptom: 'Select symptom',
    remove_selected_symptom: 'Remove the selected symptom',
    symptoms_you_chose: 'Symptoms you selected',
    no_selected_symptoms: 'No symptoms selected',
    select_symptoms_and_proceed: 'Select 1–3 most significant symptoms',
    error_max_selected_symptoms: 'You can select up to 3 symptoms or illnesses.',
    popular_symptoms_flu: 'Flu',
    popular_symptoms_heartburn: 'Heartburn',
    popular_symptoms_dizziness: 'Dizziness',
    popular_symptoms_stomach_ache: 'Stomach ache',
    popular_symptoms_headache: 'Headache',
    popular_symptoms_back_pain: 'Back pain',
    popular_symptoms_sore_throat: 'Sore throat',
    popular_symptoms_earache: 'Earache',
    popular_symptoms_fever: 'Fever',
    answer_to_questions: 'Answer the questions',
    your_symptoms_duration: 'How long have your symptoms lasted?',
    under_one_day: 'Less than 1 day',
    one_to_two_days: '1 - 2 days',
    two_to_three_days: '2 - 3 days',
    over_three_days: 'Over 3 days',
    more_information: 'Additional information',
    write_information: 'Enter the information',
    error_missing_information: 'Answer all the questions.',
    error_remote_data_failure:
      'The preliminary information survey cannot be displayed right now. Try reloading the page or continuing directly to the chat appointment.',
    summary: 'Summary',
    continue_to_chat: 'Continue to chat',
    your_answers_are_send_to_specialist:
      'The preliminary information is submitted to an expert when you go to the chat',
    choose_what_symptoms_you_have: 'Select the symptoms you have',
    answer_to_specifying_questions: 'Answer the detailed questions',
    check_summary_and_continue_to_chat: 'Check the summary and go to the chat queue ',
    patient: 'Patient',
    reason_of_contacting: 'Contact reason',
  },
};
